/**
 * Classic D: butterflies in hollows (docs/spec/03 §2). Each hollow has a shaft with a column of
 * boulders beside its top: push one in, and if it lands on the butterfly, nine diamonds.
 */

import type { CaveDef } from '../types';

export const caveD: CaveDef = {
  id: 'D',
  name: 'MOTH HOLLOW',
  hint: 'Drop a boulder on a butterfly and see what happens.',
  intermission: false,
  colors: [4, 13, 7],
  diamondValue: 15,
  extraValue: 25,
  fill: { base: '.', items: [['r', 9], ['d', 4]] },
  levels: [
    { seed: 1401, diamonds: 16, time: 150 },
    { seed: 1402, diamonds: 18, time: 140 },
    { seed: 1403, diamonds: 20, time: 130 },
    { seed: 1404, diamonds: 22, time: 120 },
    { seed: 1405, diamonds: 24, time: 110 },
  ],
  map: [
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
    'W...??????????????............?????????W',
    'W.P...........????..wrw.......?????????W',
    'W.....wrw.....????..wrw.......?????????W',
    'W???..wrw.....????...r .......?????????W',
    'W???...r .....????.... .......?????????W',
    'W???.... .....????....       .?????????W',
    'W???....     .????.... .....b.?????????W',
    'W???.... ...b.????.... ..... .........?W',
    'W???.... ... .........       .wrw.....?W',
    'W???....     .wrw.............wrw.....?W',
    'W???..........wrw.....??????...r .....?W',
    'W???????????...r .....??????.... .....?W',
    'W???????????.... .....??????....     .?W',
    'W???????????....     .??????.... ...b.?W',
    'W???????????.... ...b.??????.... ... .?W',
    'W???????????.... ... .??????.... ... .?W',
    'W???????????....     .??????....     .?W',
    'W???????????..........??????..........?W',
    'W??????????????????????????????????????W',
    'W????????????????????????????????????X?W',
    'WWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWWW',
  ],
};
